// Sometimes we want to open the chat with a button click event. For this we use the function
export const forceOpenTawkDialog = () => {
  window.Tawk_API?.maximize();
};
